import { MatchRepository, ParticipantRepository, TournamentRepository } from '../repositories';

export class DeleteTournamentUseCase {
  constructor(
    private tournamentRepository: TournamentRepository,
    private participantRepository: ParticipantRepository,
    private matchRepository: MatchRepository
  ) {}

  async execute(tournamentId: string): Promise<void> {
    // Get tournament
    const tournament = await this.tournamentRepository.getById(tournamentId);
    if (!tournament) {
      throw new Error('Tournament not found');
    }

    // Delete all matches
    const matches = await this.matchRepository.getByTournamentId(tournamentId);
    for (const match of matches) {
      await this.matchRepository.delete(match.id);
    }

    // Delete all participants
    const participants = await this.participantRepository.getByTournamentId(tournamentId);
    for (const participant of participants) {
      await this.participantRepository.delete(participant.id);
    }

    // Delete tournament
    await this.tournamentRepository.delete(tournamentId);
  }
}